export const Input = {
  defaultProps: {
    focusBorderColor: 'brand.secondary',
  },
}
